import { render, staticRenderFns } from "./NewGroup.vue?vue&type=template&id=9e9fb770"
import script from "./NewGroup.vue?vue&type=script&lang=js"
export * from "./NewGroup.vue?vue&type=script&lang=js"
import style0 from "./NewGroup.vue?vue&type=style&index=0&id=9e9fb770&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports